import { z } from "zod";

export const LoginUserSchema = z.object({
  id: z.union([z.number(), z.string()]).optional().nullable(),
  username: z.string().optional().nullable(),
  email: z.string().optional().nullable(),
  // first_name / last_name / name come straight from UserProfile on the
  // backend (see accounts.views.LoginUser). `name` is the pre-composed
  // display string when the profile carries it; first_name + last_name are
  // the canonical components UserItem composes from when `name` is blank.
  first_name: z.string().optional().nullable(),
  last_name: z.string().optional().nullable(),
  name: z.string().optional().nullable(),
  phone_number: z.string().optional().nullable(),
  profile_picture: z.string().optional().nullable(),
  country: z.string().optional().nullable(),
  city: z.string().optional().nullable(),
  language: z.string().optional().nullable(),
  role: z.string().optional().nullable(),
});

export const LoginResponseSchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
  access_token: z.string().optional(),
  refresh_token: z.string().optional(),
  expires_in: z.number().optional(),
  user: LoginUserSchema.optional(),
  customCode: z.string().optional(),
});

export const LoginRequestSchema = z.object({
  identifier: z.string().min(1, "Identifier is required"),
  password: z.string().min(1, "Password is required"),
});

export type LoginUser = z.infer<typeof LoginUserSchema>;
export type LoginResponse = z.infer<typeof LoginResponseSchema>;
export type LoginRequest = z.infer<typeof LoginRequestSchema>;
